import { render } from "./growthCenter.vue?vue&type=template&id=1d07fd40&scoped=true"
import script from "./growthCenter.vue?vue&type=script&lang=js"
export * from "./growthCenter.vue?vue&type=script&lang=js"

import "./growthCenter.vue?vue&type=style&index=0&id=1d07fd40&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d07fd40"]])

export default __exports__